export default class Home {
  show() {}

  hide() {}
}
